import React from 'react';

interface ImportProgressProps {
  messages: string[];
}

const ImportProgress: React.FC<ImportProgressProps> = ({ messages }) => {
  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="import-progress">
      <h3>Import Progress</h3>
      <div className="progress-messages">
        {messages.map((message, index) => {
          const isSuccess = message.includes('✓');
          const isError = message.includes('✗');
          return (
            <div
              key={index}
              className={`progress-message ${isSuccess ? 'success' : ''} ${
                isError ? 'error' : ''
              }`}
            >
              {message}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImportProgress;

